import { __extends, __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import { Editor } from 'react-draft-wysiwyg';
import { encodeSvg } from '../../util/_internal/encodeSvg.js';
import { ReactComponent as SvgAlignmentCenter } from './icons/alignment_center.svg.js';
import { ReactComponent as SvgAlignmentJustify } from './icons/alignment_justify.svg.js';
import { ReactComponent as SvgAlignmentLeft } from './icons/alignment_left.svg.js';
import { ReactComponent as SvgAlignmentRight } from './icons/alignment_right.svg.js';
import { ReactComponent as SvgBold } from './icons/bold.svg.js';
import { ReactComponent as SvgItalic } from './icons/italic.svg.js';
import { propTypes, defaultProps } from './RichTextEditor.types.js';
import styles from './RichTextEditor.module.scss.js';
import './RichTextEditor.css.js';

// Type to any to avoid "JSX element type does not have any construct or call signatures" error
var AlignmentCenterIcon = SvgAlignmentCenter;
var AlignmentJustifyIcon = SvgAlignmentJustify;
var AlignmentLeftIcon = SvgAlignmentLeft;
var AlignmentRightIcon = SvgAlignmentRight;
var BoldIcon = SvgBold;
var ItalicIcon = SvgItalic;
var RichTextEditor = /** @class */ (function (_super) {
    __extends(RichTextEditor, _super);
    function RichTextEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.toolbarConfig = {
            options: ['fontFamily', 'fontSize', 'inline', 'textAlign'],
            inline: {
                bold: {
                    icon: encodeSvg(React__default.createElement(BoldIcon, null)), // Icon must be encoded png/svg according to documentation https://jpuri.github.io/react-draft-wysiwyg/#/demo
                },
                italic: {
                    icon: encodeSvg(React__default.createElement(ItalicIcon, null)),
                },
                inDropdown: false,
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
                options: ['bold', 'italic'],
            },
            fontSize: {
                options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96],
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
            },
            fontFamily: {
                options: [
                    'Arial',
                    'Georgia',
                    'Impact',
                    'Tahoma',
                    'Times New Roman',
                    'Verdana',
                ],
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
            },
            textAlign: {
                inDropdown: false,
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
                options: ['left', 'center', 'right', 'justify'],
                left: {
                    icon: encodeSvg(React__default.createElement(AlignmentLeftIcon, null)),
                },
                center: {
                    icon: encodeSvg(React__default.createElement(AlignmentCenterIcon, null)),
                },
                right: {
                    icon: encodeSvg(React__default.createElement(AlignmentRightIcon, null)),
                },
                justify: {
                    icon: encodeSvg(React__default.createElement(AlignmentJustifyIcon, null)),
                },
            },
        };
        _this.onEditorStateChange = _this.onEditorStateChange.bind(_this);
        return _this;
    }
    RichTextEditor.prototype.onEditorStateChange = function (editorState) {
        this.props.onStateChange(editorState);
    };
    RichTextEditor.prototype.render = function () {
        var _a = this.props, editorState = _a.editorState, className = _a.className, placeholder = _a.placeholder, label = _a.label;
        return (React__default.createElement("div", { className: clsx(styles.RichTextEditor, className) },
            React__default.createElement("label", { className: clsx(styles.InputLabel, !label && styles.InputLabel___hidden) }, label),
            React__default.createElement(Editor, { editorState: editorState, toolbarClassName: styles.RichTextEditorToolbar, wrapperClassName: styles.RichTextEditorWrapper, editorClassName: styles.RichTextEditorEditor, onEditorStateChange: this.onEditorStateChange, toolbar: this.toolbarConfig, placeholder: placeholder })));
    };
    RichTextEditor.displayName = 'RichTextEditor';
    RichTextEditor.propTypes = propTypes;
    RichTextEditor.defaultProps = __assign({}, defaultProps);
    return RichTextEditor;
}(React__default.Component));

export { RichTextEditor as default };
